'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import connectDropTargetDecorator from '../draggable/connectDropTarget';
import connectDragSourceDecorator from '../draggable/connectDragSource';
import { ConnectDragSourceContextProvider } from '../context/ConnectDragSourceContext';
import { jsx as _jsx } from "react/jsx-runtime";
class UIDragListItem extends Component {
  render() {
    const {
      children,
      className,
      connectDragPreview,
      connectDragSource,
      connectDropTarget,
      isDragging,
      style
    } = this.props;
    return connectDragPreview(connectDropTarget( /*#__PURE__*/_jsx("div", {
      className: className,
      style: isDragging ? Object.assign({}, style, {
        opacity: 0
      }) : style,
      children: /*#__PURE__*/_jsx(ConnectDragSourceContextProvider, {
        value: connectDragSource,
        children: children
      })
    })));
  }
}
UIDragListItem.propTypes = {
  isDragging: PropTypes.bool,
  connectDragSource: PropTypes.func,
  connectDragPreview: PropTypes.func,
  connectDropTarget: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  style: PropTypes.object
};
const ConnectedDragListItem = connectDragSourceDecorator(connectDropTargetDecorator(UIDragListItem));
ConnectedDragListItem.propTypes = Object.assign({}, UIDragListItem.propTypes);
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ConnectedDragListItem.defaultProps = Object.assign({}, UIDragListItem.defaultProps);

// Replaces HOC wrapper names with UIDragListItem in Storybook 'Show code' blocks
ConnectedDragListItem.displayName = 'UIDragListItem';
export default ConnectedDragListItem;